// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control.is-invalid {
  border-right-width: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-input-text/s1-input-text.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourcesContent":[".form-control.is-invalid {\n  border-right-width: 5px;\n  //background-color: $danger;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
